<template>
  <div style="    position: relative;height:100%;overflow: hidden;">
    <div class="rc-title flex-between">
      <div>取单({{arr.length}})</div>
      <div class="back" @click="back">X</div>
    </div>
    <div class="content" v-if="arr.length !== 0">
      <div class="item" v-for="(item,index) in arr" :key="index">
        <div class="flex-between row">
          <div class="totalPrice">
            订单总价：
            <span>￥{{item.totalPrice.toFixed(2)}}</span>
          </div>
          <div class="time">挂单时间：{{item.time}}</div>
        </div>
        <div class="goods-wrapper">
          <div class="goods-item column" v-for="(item2,index2) in item.list" :key="index2">
            <div class="goods-name">{{item2.goodsName}} ({{item2.valueContent}})</div>
            <div class="row alignCenter">
              <div style="margin-right:9px">￥{{item2.retailPrice.toFixed(2)}}</div>
              <div class="goods-unit">{{item2.goodsNum}}{{item2.goodsUnit}}</div>
            </div>
          </div>
        </div>
        <div class="flex-between center">
          <div class="totalPrice" style="width: 78%;">挂单备注：{{item.orderMark}}</div>
          <div>
            <el-button size="small" type="primary" @click="delMonads(index)" plain>删除</el-button>
            <el-button
              size="small"
              type="primary"
              @click="orderMark(index)"
              plain
            >{{!item.orderMark?'添加备注':'修改备注'}}</el-button>
            <el-button size="small" type="primary" @click="fetchMonads(index)" :disabled="disabled">取单</el-button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="arr.length == 0" style="padding: 20px;">暂无挂单记录</div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      arr: [],
      disabled: false
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
  //当前时间
    getTime(date) {
      if (date) {
        var myDate = date;
      } else {
        var myDate = new Date();
      }
      myDate.getYear(); //获取当前年份(2位)
      var month = myDate.getMonth() + 1;
      let str = myDate.getFullYear() + "-" + month + "-" + myDate.getDate();
      var date = myDate.getDate();
      var hours = myDate.getHours();
      var minutes = myDate.getMinutes();
      var seconds = myDate.getSeconds();
      if (date < 10) {
        date = "0" + date;
      }
      if (month < 10) {
        month = "0" + month;
      }
      if (minutes < 10) {
        minutes = "0" + minutes;
      }
      if (seconds < 10) {
        seconds = "0" + seconds;
      }
      if (hours < 10) {
        hours = "0" + hours;
      }
      var time =
        myDate.getFullYear() +
        "-" +
        month +
        "-" +
        date +
        " " +
        hours +
        ":" +
        minutes +
        ":" +
        seconds;
      return time;
    },
    //取单
    fetchMonads(index) {
      // debugger
      var arr = JSON.parse(window.localStorage.goodsMonads);
      var cartList = this.$store.state.cartList;
      var newArr = arr[index]; //要取出的单
      var oldArr = { list: [] }; //要替换的单
      var newCartList = [];
      newArr.list.forEach((e, a) => {
        newCartList.push(e);
      }); //对象转购物车数组
      if (cartList.length != 0) {
        console.log(1, 'cartList长度不为0')
        console.log(this.$store.state.takeOutCartList, 'this.$store.state.takeOutCartList')
        this.disabled = true
        this.$confirm("此操作将会清空购物车, 是否继续", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: 'warning'
        })
        .then(({ value }) => {
          // this.$store.commit("clearCartList");
          // this.$store.commit("countTotalPrice");
          // this.$store.commit("countCartListPrice");
          // this.$store.commit("clearOffers");
          // this.$store.state.saleUserId = ""
          this.disabled = false
          this.$store.state.cartList = newCartList;
          this.$store.state.takeOutCartList = newArr;
          this.$store.state.saleUserId = newArr.saleUserId;
          this.$store.commit("clearOffers");
          this.$store.commit("countTotalPrice");
          arr.splice(index, 1)
          window.localStorage.setItem("goodsMonads", JSON.stringify(arr));
          this.$message({
            type: "success",
            message: "取单成功"
          });
          this.$router.push("/cashierOrder/cashierOrderHome");
        })
        .catch(() => {
          this.disabled = false
        });
        return
        // if (this.$store.state.takeOutCartList.length == 0) {
        //   console.log(2, 'takeOutCartList长度为0')
        //   //判断购物车单是否已有数据格式
        //   cartList.forEach((e, a) => {
        //     oldArr.list.push(e);
        //   }); //购物车数组转换成对象
        //   oldArr.time = this.getTime();
        //   oldArr.orderMark = "";
        //   oldArr.saleUserId = this.$store.state.saleUserId;
        // } else {
        //   console.log(3, 'takeOutCartList长度不为0')
        //   oldArr = this.$store.state.takeOutCartList;
        // }
        // arr[index] = oldArr; //购物车数组替换掉已挂单
      } else {
        console.log(1)
        arr.splice(index, 1);
      }
      // console.log(arr)
      // 重新排序
      arr.forEach(item => {
        var str = item.time.replace(/-/g, "/");
        var date = new Date(str);
        item.time = date.getTime();
      });
      var compare = function(prop) {
        return function(obj1, obj2) {
          var val1 = obj1[prop];
          var val2 = obj2[prop];
          if (!isNaN(Number(val1)) && !isNaN(Number(val2))) {
            val1 = Number(val1);
            val2 = Number(val2);
          }
          if (val1 < val2) {
            return 1;
          } else if (val1 > val2) {
            return -1;
          } else {
            return 0;
          }
        };
      };
      arr = arr.sort(compare("time"));
      arr.forEach(item => {
        var date = new Date(item.time);
        item.time = this.getTime(date);
        // console.log(this.getTime(date), "date");
      }); //重新排序
      this.$store.state.cartList = newCartList;
      this.$store.state.takeOutCartList = newArr;
      console.log(this.$store.state.takeOutCartList, 'this.$store.state.takeOutCartList11111')
      this.$store.state.saleUserId = newArr.saleUserId;
      window.localStorage.setItem("goodsMonads", JSON.stringify(arr));
      this.$store.commit("clearOffers");
      this.$store.commit("countTotalPrice");

      this.$message({
        type: "success",
        message: "取单成功"
      });
      this.$router.push("/cashierOrder/cashierOrderHome");
      this.fetchData();
    },
    //从store取数据
    fetchData() {
      var arr = JSON.parse(window.localStorage.goodsMonads);
      arr.forEach(i => {
        let totalPrice = 0;
        i.list.forEach(a => {
          totalPrice += a.retailPrice * a.goodsNum;
        });
        i.totalPrice = totalPrice;
      });
      this.arr = arr;
    },
    //删除单
    delMonads(index) {
      var arr = JSON.parse(window.localStorage.goodsMonads);
      arr.splice(index, 1);
      window.localStorage.setItem("goodsMonads", JSON.stringify(arr));
      this.$message({
        type: "success",
        message: "删除成功"
      });
      this.fetchData();
    },
    upDate() {
      var arr = this.arr;
      this.arr = [];
      this.arr = arr;
    },
    orderMark(index) {
      this.$prompt("请输入备注", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputValue: this.arr[index].orderMark
      })
        .then(({ value }) => {
          this.$message({
            type: "success",
            message: "已备注: " + value
          });
          this.arr[index].orderMark = value;
          this.upDate();
          window.localStorage.setItem("goodsMonads", JSON.stringify(this.arr));
          console.log(JSON.parse(window.localStorage.goodsMonads), "3");
        })
        .catch(() => {});
    },
    back() {
      this.$router.go(-1);
    }
  }
};
</script>
<style  scoped>
.item {
  border-bottom: 1px solid #e2e2e2;
}
.goods-name {
  margin-bottom: 7px;
  display: -webkit-box;
  overflow: hidden;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: break-all;
  word-wrap: break-word;
}
.goods-unit {
  font-size: 12px;
  color: rgba(153, 153, 153, 1);
}
.goods-item {
  position: relative;
  box-sizing: border-box;
  display: inline-flex;
  width: auto;
  height: 71px;
  overflow: hidden;
  color: #333;
  background-color: #f8f8f9;
  border-radius: 2px;
  padding: 13px 15px;
  font-size: 14px;
}
.goods-wrapper {
  position: relative;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 270px));
  grid-gap: 20px;
}
.time {
  font-size: 12px;
  color: rgba(153, 153, 153, 1);
  line-height: 48px;
}
.totalPrice {
  font-size: 14px;
  color: rgba(102, 102, 102, 1);
  line-height: 48px;
}
.totalPrice span {
  color: #fe0202;
}
.content {
  padding: 10px 30px 30px 10px;
  padding-left: 10px;
  overflow-y: scroll;
  height: calc(100% - 100px);
  scrollbar-width: none; /* Firefox 隐藏滚动条*/
  -ms-overflow-style: none; /* IE 10+ 隐藏滚动条*/
}
/* 隐藏滚动条 */
.content::-webkit-scrollbar {
  display: none; /* Chrome Safari */
}
.back {
  color: gray;
  font-size: 20px;
  cursor: pointer;
}
.rc-title {
  /* background: #eeeeee; */
  border-bottom: 1px solid #eee;
  box-sizing: border-box;
  padding: 18px;
  height: 60px;
  font-size: 16px;
}
</style>


// WEBPACK FOOTER //
// src/components/page/cashierGoodsMonads.vue